{
	"ariaTutorials": "tutorials",
	"adjustProjectNamesDatesDesc": "Learn how to adjust project names and dates.",
	"adjustProjectNamesDatesTitle": "How to Adjust Project Names and Dates",
	"createFirstProjectDesc": "Learn how to setup your first project and AI Style.",
	"createFirstProjectTitle": "Create your first {{productName}} project",
	"createProjectDesc": "Learn how to create a project in Pixieset Photo Editor.",
	"createProjectTitle": "How to Create a Project in Photo Editor",
	"cullingModeDesc": "Learn how to group, rate and sort photos in Culling Mode.",
	"cullingModeTitle": "Use Culling Mode",
	"dataPersistenceDesc": "Learn how {{productName}} stores your data",
	"dataPersistenceTitle": "Data persistence and privacy",
	"hidePhotosDesc": "Learn how to hide and unhide photos",
	"hidePhotosTitle": "Hide photos",
	"improveStyleDesc": "Learn how to use mark reference to continuously provide AI feedback.",
	"improveStyleTitle": "Improve your AI Style",
	"lockEditGuideDesc": "Learn how Lock Edit works.",
	"lockEditGuideTitle": "How Lock Edit Works",
	"locateLrPresetsDesc": "Learn how to use existing LR presets & Profiles in {{productName}}.",
	"locateLrPresetsTitle": "Locate LR presets to import",
	"lockEditDesc": "Learn what is Lock edit and how to use it.",
	"lockEditTitle": "Learn to use Lock Edit",
	"lrPresetAsBaseDesc": "Learn how to use existing LR presets for your base edits.",
	"lrPresetAsBaseTitle": "Use LR Preset as Base",
	"maskingToolsDesc": "Get familiar with the core masking tools and how to use them.",
	"maskingToolsTitle": "Getting Started with Masking Tools",
	"preTrainedStyleDesc": "Start a project without training your own AI Style",
	"preTrainedStyleTitle": "Use pre-trained AI Style",
	"quickTourDesc": "An overview of Pixieset Photo Editor",
	"quickTourTitle": "Quick Tour",
	"reorderPhotosDesc": "Reordering is easy in {{productName}}",
	"reorderPhotosTitle": "Reorder photos in your project",
	"retouchPhotosDesc": "See how to retouch images using AI Erase, AI Gen, and Healing.",
	"retouchPhotosTitle": "How to Retouch Photos with AI Erase, AI Gen & Healing",
	"sectionEditing": "Editing",
	"sectionGetStarted": "Get Started",
	"sectionAiStyles": "AI Styles",
	"smartCullingDesc": "Learn how to cull with Pixieset Photo Editor.",
	"smartCullingTitle": "Smart Culling with AI",
	"smartEditingDesc": "Learn how to edit photos in Pixieset Photo Editor.",
	"smartEditingTitle": "Smart Editing with AI",
	"createAiStyleWithGalleryTitle": "How to Create an AI Style with a Pixieset Gallery",
	"createAiStyleWithGalleryDesc": "Learn how to create an AI Style with a Pixieset Gallery.",
	"createAiStyleByUploadTitle": "How to Create an AI Style by Uploading Images",
	"createAiStyleByUploadDesc": "Learn how to create an AI Style by uploading images.",
	"trainImproveAiStyleTitle": "How to Train and Improve Your AI Style",
	"trainImproveAiStyleDesc": "Learn how to train and improve your AI Style.",
	"createAiStyleBranchTitle": "How to Create an AI Style Branch",
	"createAiStyleBranchDesc": "Learn how to create an AI Style branch.",
	"switchStylesDesc": "Learn how to use a different AI Styles",
	"switchStylesTitle": "Switch AI Styles in a project",
	"transferLookDesc": "Learn to instantly match the editing style of any photo.",
	"transferLookTitle": "Transfer the look from any photo",
	"tutorials": "Tutorials",
	"virtualCopyGuideDesc": "Learn how to create a virtual copy.",
	"virtualCopyGuideTitle": "How to Create a Virtual Copy",
	"virtualCopiesDesc": "Learn how to create virtual copies",
	"virtualCopiesTitle": "Use virtual copies",
	"whatIsPhotoEditorDesc": "Quick 2-minutes introduction to Photo Editor",
	"whatIsPhotoEditorTitle": "What is Pixieset Photo Editor?"
}
